import { useMemo, useState } from 'react'

import { IHighlightsFolder } from '@/types/highlight.interface'

export const useHighlightFolderSelection = (folders: IHighlightsFolder[]) => {
	const [isSelectMode, setIsSelectMode] = useState(false)
	const [selectedFolderIds, setSelectedFolderIds] = useState<number[]>([])

	const toggleFolderSelection = (folderId: number) => {
		setSelectedFolderIds(prev =>
			prev.includes(folderId)
				? prev.filter(id => id !== folderId)
				: [...prev, folderId]
		)
	}

	const cancelFolderSelection = () => {
		setIsSelectMode(false)
		setSelectedFolderIds([])
	}

	const visibleFolders = useMemo(() => {
		if (!isSelectMode) return folders

		return folders.filter(folder => selectedFolderIds.includes(folder.id))
	}, [folders, isSelectMode, selectedFolderIds])

	return {
		isSelectMode,
		setIsSelectMode,
		selectedFolderIds,
		setSelectedFolderIds,
		toggleFolderSelection,
		cancelFolderSelection,
		visibleFolders
	}
}
